export const colors = {
  textMain: '#2D2C2C',
  textSecondary: '#000000',
  labelText: '#452E1E',
  placeholderText: '#746F6B',
  sidebarHover: '#ffffff',
  sidebarBackground: '#5F9069',
  tableRowBackground: '#EBF9F1',
  cardBackground: '#dfebe2',

  newStatusBackground: '#C2CCE1',
  newStatusText: '#ffffff',
  assignedBackground: '#bad1f3',
  assignedText: '#ffffff',
  notCompletedBackground: '#f0bfbf',
  inProgressBackground: '#4A90E2',
  notCompletedText: '#A30D11',
  completedBackground: '#1F9254',
  completedText: '#ffffff',
  missedBackground: '#ce3011ff',
  missedText: '#ffffff',
  partialBackground: '#FEF2E5',
  pendingBackground: '#e4ad7c',
  partialText: '#CD6200',

  checkEvidenceBackground: '#EE7E1C',

  sidebarActiveColor: '#ffffff',
  sidebarActiveBackgroundColor: '#3D5942',

  primary: '#5F9069', // dropdown bg color
  secondary: '#F3F5F9', //
  primaryLight: '#DFEBE2',
  // primaryLight: '#eaf9f7',
  primaryDisabled: '#dce2ef',

  success: '#4AB37B',
  successMedium: '#d4f4ee',
  successLight: '#CCEBDA',

  warning: '#EA9F48',
  warningMedium: '#fad59d',
  warningLight: '#fdf3e4',

  error: '#EF717D',
  errorMedium: '#ffacb4',
  errorLight: '#fff6f7',
  errorDisabled: '#ffc7cc',

  purple: '#6f7aff',
  purpleMedium: '#9a96f9',
  purpleLight: '#d9d7fc',

  blue: '#4d94fb',
  blueMedium: '#98c3ff',
  blueLight: '#d2e4fe',

  violet: '#6776CB',

  gray: '#7f9dbf', // mark as paid
  grayMedium: '#B0CBD6', // save as draft
  grayLight: '#CDE2EA',
  grayHover: '#8DADBA',

  sand: '#AF9B89',
  sandMedium: '#CCBAA9',
  sandLight: '#F4E3D4',

  // plan gray color
  planGray: '#6686a2',
  playGrayLight: '#eaf2f9',

  blackButton: '#465065',
  focusShadow: '#F5F5F5',

  white: '#fff',
  whiteBg: '#fcfdfe',
};

export const hoverColors = {
  primary: '#57a466',
  error: '#ed5160',
  warning: '#f09b16',
  purpleMedium: '#8985ea',
  blue: '#3f86f0',
  gray: '#6d8caf',
  grayMedium: '#8ea1b5',
  planGray: '#617f9a',
  blackButton: '#1f2939',
};

export const dashboardColors = {
  total_employees: '#7F9DBF',
  working_today: '#41CB8F',
  not_working_today: '#C83A6E',
  total: '#916246',
  all_tasks: '#916246',
  in_progress: '#916246',
  open: '#D9A777',
  to_do: '#D9A777',
  new: '#D9A777',
  re_assigned: '#D9A777',
  not_completed: '#4A90E2',
  partial: '#4A90E2',
  in_progress: '#4A90E2',
  partially_completed: '#4A90E2',
  partially_complete: '#4A90E2',
  cancelled: '#F7B955',
  missed: '#D9A777',
  totally_missed: '#F7B955',
  completed: '#72CC6D',
  complete: '#72CC6D',
  pending_approval: '#B48963',
  approved: '#27AE60',
  rejected: '#E0627A',
  closed: '#b1abac',
};

export const dashboardStatusColors = {
  new: '#7f9dbf',
  new_ticket: '#7f9dbf',
  assigned: '#458ee2',
  completed: '#4AB37B',
  complete: '#4AB37B',
  partial: '#EA9F48',
  missed: '#e24151',
  cancelled: '#EF717D',
  closed: '#6776CB',
  re_assigned: '#D9A777',
  approved: '#27AE60',
  rejected: '#E0627A',
  pending: '#B48963',
  in_progress: '#4A90E2',
};

export const borderColors = {
  primary: colors.primary,
  secondary: '#2D2C2C',
  secondaryLight: '#e4e7eb',
  blackButton: '#1f2939',
  error: colors.error,
};

export const hoverBorderColors = {
  secondaryLight: '#434343b3',
};
